<clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'order_id'" [clrDgSortOrder]="descSort">Auftrag</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Auftragnehmer</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_subject'">Beschreibung</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_date'">Datum</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_delivery'">Liefertermin</clr-dg-column>
    <clr-dg-column [clrDgField]="'reqid'">Referenz (Request)</clr-dg-column>
    <clr-dg-column [clrDgField]="'job_id'">Referenz (Job)</clr-dg-column>
    <clr-dg-column>Summe (netto)</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Order for this Project!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let order of orders">
        <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]">{{ order.project_id }}.0002.{{ order.order_id }}</clr-dg-cell>
        <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]">{{ order.company_name }}<br />({{order.order_salutation}} {{ order.order_firstname }} {{ order.order_lastname }})</clr-dg-cell>
        <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]"><b>{{ order.order_subject }}</b></clr-dg-cell>
        <clr-dg-cell>{{ order.order_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
        <clr-dg-cell>{{ order.order_delivery | date: 'dd.MM.yyyy' }}</clr-dg-cell>
        <clr-dg-cell [routerLink]="['/request/details', order.project_id, order.reqid]">{{ order.project_id }}.0001.{{ order.reqid }}</clr-dg-cell>
        <clr-dg-cell [routerLink]="['/job/details', order.project_id, order.job_id]">{{ order.project_id }}.0006.{{ order.job_id }}</clr-dg-cell>
        <clr-dg-cell class="currency"><b>{{ order.purchasing_price | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
        <clr-dg-cell [className]="findButtonClass(order.order_status)" role="alert">
            <div class="alert-items">
                <div class="alert-item static">
                    <span class="alert-text">{{ getCellStatus(order.order_status).statusDisplay}}</span>
                </div>
            </div>
        </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Aufträge pro Seite</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
            von {{orders.length}} Aufträge(n)
        </clr-dg-pagination>
    </clr-dg-footer>
</clr-datagrid>
